module.exports = __webpack_public_path__ + "img/domain.ad03bd8c.svg";